import { useQuery } from 'hooks/useQuery'

import { fetchSubscriptionsByProgramId, fetchSubscriptionsByTrainerId } from 'utils/queries'

import { Subscription } from 'types/subscription'

/**
 * Fetch users' Subscriptions who are subscribed to the provided trainerId.
 */
export const useSubscriptions = ({ trainerId }: { trainerId?: string; limit?: number }) => {
  return useQuery<Array<Subscription>>(
    ['subscriptions', trainerId],
    () => fetchSubscriptionsByTrainerId({ trainerId }),
    {
      enabled: !!trainerId,
    },
  )
}

/**
 * Fetch users' Subscriptions who are subscribed to the provided programId.
 */
export const useProgramSubscriptions = ({ programId }: { programId?: string; limit?: number }) => {
  return useQuery<Array<Subscription>>(
    ['programSubscriptions', programId],
    () => fetchSubscriptionsByProgramId(programId),
    {
      enabled: !!programId,
    },
  )
}
